import styled from "styled-components";

export const Styles = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  padding: 0 4px;
  text-align: left;
  white-space: nowrap;
`;
